import { Mapper } from "../../../../base/utils/mapper";
import { InvoiceRIPSConfigurationModel } from "../../../../domain/models/configuration/invoice-rips-configuration.model";
import { InvoiceRIPSConfigurationEntity } from "../entities/invoice-rips-configuration/invoice-rips-configuration.entity";

export class InvoiceRIPSConfigurationImplementationRepositoryMapper extends Mapper<InvoiceRIPSConfigurationEntity, InvoiceRIPSConfigurationModel> {
	mapFrom(param: InvoiceRIPSConfigurationEntity): InvoiceRIPSConfigurationModel {
		return {
			data:param.data,
			isSuccess:param.isSuccess,
			message:param.message,
			errors:param.errors
		};
	}
	mapTo(param: InvoiceRIPSConfigurationModel): InvoiceRIPSConfigurationEntity {
		return {
			data:param.data,
			isSuccess:param.isSuccess,
			message:param.message,
			errors:param.errors
		}
	}
}